// const IP = 'localhost:8000';
const IP = process.env.NODE_ENV === 'production' ? 'api.strategy-offsite-meeting.com' : 'localhost:8000';
// const IP = 'api.strategy-offsite-meeting.com'

// const IP = 'www.2024.som2022.com';


export default IP;